<template>
  <div
    class="workToDo"
  >
    <v-card
      minHeight="120"
      tile
    >
      <v-container p0>
        <v-row noGutters>
          <v-col cols="9">
            <v-list-item>
              <v-list-item-content>
                <v-list-item-title class="subheading card-title">
                  {{ $t('dashboard.workToComplete.' + work.title) | uppercase }}
                </v-list-item-title>
              </v-list-item-content>
            </v-list-item>
          </v-col>
          <v-col cols="3">
            <v-sheet
              tile
              color="primary"
              height="120"
              class="d-flex align-center justify-center white--text display-1 "
            >
              {{ work.count || '-' }}
            </v-sheet>
          </v-col>
        </v-row>
      </v-container>
    </v-card>
  </div>
</template>

<script>
export default {
    name: 'WorkToComplete',
    props: {
        work: {
            type: Object,
            required: true,
        },
    },
};
</script>

<style lang='scss' scoped>
  .card-title {
    letter-spacing: .05em;
    font-weight: 500;
    white-space: normal;
  }
</style>
